import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "payment-club",
      class: { "payment-club_club-border": _setup.isClubEnabled },
      attrs: { "data-qa": "payment_club" },
    },
    [
      _c(
        "div",
        { staticClass: "payment-club__inner d-flex flex-column gr-3" },
        [
          _c(
            "div",
            { staticClass: "rounded elevation-1" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column gr-4 rounded-t bg-club py-4 px-5",
                },
                [
                  _c(_setup.ClubSwitch, {
                    attrs: {
                      "data-qa": "payment_club_switch",
                      title: "Клубная цена",
                      discount: _vm.clubOfferData?.clubDiscount,
                    },
                    model: {
                      value: _setup.isClubEnabled,
                      callback: function ($$v) {
                        _setup.isClubEnabled = $$v
                      },
                      expression: "isClubEnabled",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _setup.clubCardDateEnd
                        ? _c(
                            "div",
                            { staticClass: "text-body-2 text-secondary--text" },
                            [
                              _vm._v("\n            Вы в клубе до "),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-qa": "payment_club_card_date_end",
                                  },
                                },
                                [_vm._v(_vm._s(_setup.clubCardDateEnd))]
                              ),
                              _vm._v(" 👑\n          "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(_setup.ClubInfo, {
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-body-2 primary--text cursor-pointer",
                                    attrs: {
                                      "data-qa": "payment_club_more_activator",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return on.click.apply(null, arguments)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Подробнее о клубе\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(_setup.PriceDetails, {
                attrs: {
                  "full-price": _vm.fullPrice,
                  "lpu-price": _vm.clubOfferData?.lpuPrice,
                  "option-price": _vm.clubOfferData?.couponPrice,
                  "total-price": _vm.clubOfferData?.totalPrice,
                  "card-price": _vm.clubOfferData?.cardPrice,
                  "is-no-card": !_vm.clubOfferData?.cardDateEnd,
                  "is-club-enabled": _setup.isClubEnabled,
                },
              }),
              _vm._v(" "),
              _setup.isClubEnabled
                ? _c(
                    "div",
                    { staticClass: "px-5 pb-5" },
                    [
                      _c(VCheckbox, {
                        ref: "acceptedOptionNonRefundableRef",
                        staticClass: "payment-club__checkbox mt-0 pt-0 mb-5",
                        attrs: {
                          "data-qa":
                            "payment_club_accepted_option_non_refundable_checkbox",
                          rules: [_setup.acceptedOptionNonRefundableRule],
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "text-body-2 text--text" },
                                    [
                                      _vm._v(
                                        "\n              Принимаю условие, что опцион на скидку невозвратный\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "message",
                              fn: function ({ message }) {
                                return [
                                  _c("span", { staticClass: "ml-8" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(message) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          920977252
                        ),
                        model: {
                          value:
                            _setup.clubDataStore.isAcceptedOptionNonRefundable,
                          callback: function ($$v) {
                            _vm.$set(
                              _setup.clubDataStore,
                              "isAcceptedOptionNonRefundable",
                              $$v
                            )
                          },
                          expression:
                            "clubDataStore.isAcceptedOptionNonRefundable",
                        },
                      }),
                      _vm._v(" "),
                      _vm._t("default", null, {
                        isClubEnabled: _setup.isClubEnabled,
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_setup.isClubEnabled
            ? _c(_setup.ClubDiscountBanner, {
                attrs: {
                  "full-price": _vm.fullPrice,
                  "total-price": _vm.clubOfferData?.totalPrice,
                  "card-price": _vm.clubOfferData?.cardPrice,
                },
                on: {
                  click: function ($event) {
                    _setup.isClubEnabled = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_setup.isClubEnabled
            ? _vm._t("default", null, { isClubEnabled: _setup.isClubEnabled })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }